import { store } from "../store";
import DataStructure, { sanitize } from "./DataStructure";
import { DialogRouter } from "../boot/dialogs";
import { deepFreeze } from "../util/misc";
import { router } from "../router";

export const LOG_FIELDS = {
  uid: "",
  event: "",
  before: null,
  after: null,
  path: "",
  collection: "",
  doc: "",
  // Every document ID along `path`, the document's own included — what the
  // admin Logs page's document filter searches with `array-contains` so one ID
  // finds a document and everything nested under it. Written by
  // functions/logs.js; absent on logs written before it was added.
  pathDocs: null,
  timestamp: null,
};
deepFreeze(LOG_FIELDS);

export default class Log extends DataStructure {
  constructor(id, data = {}) {
    super(sanitize(data, LOG_FIELDS));
    this.id = id || null;
  }

  // Database

  get path() {
    return Log.getPath(this.id);
  }

  static getPath(id) {
    let path = `logs`;
    if (id) {
      path += `/${id}`;
    }
    return path;
  }

  static toFirestore(log) {
    return log.data;
  }

  static fromFirestore(snapshot, options) {
    const data = snapshot.data(options);
    return new Log(snapshot.id, data);
  }

  // Formatting

  get routes() {
    if (this.data.event === "delete") {
      return null;
    }
    const path = this.data.path;
    const routes = { dialog: null, route: null };
    if (this.data.collection === "users") {
      const user = store.state.main.users[this.data.doc];
      const type =
        !user || user.isDisabled
          ? "disabled"
          : user.isCustomer
          ? "customers"
          : "employees";
      routes.dialog = DialogRouter.match(
        `/admin/users/${type}/${this.data.doc}/view/`
      );
    } else if (this.data.collection === "companies") {
      const company = store.state.main.companies[this.data.doc];
      const type = !company || company.isVendor ? "vendors" : "customers";
      routes.dialog = DialogRouter.match(
        `/admin/companies/${type}/${this.data.doc}/view/`
      );
    } else if (
      ["orders", "acks", "bills", "packing-slips"].includes(
        this.data.collection
      )
    ) {
      let path = this.data.path.split("/");
      path.splice(5, 0, "vendor/unknown");
      path = path.join("/") + "/view";
      routes.dialog = DialogRouter.match(path);
    } else if (this.data.collection === "invoices") {
      let path = this.data.path.split("/");
      path.splice(5, 0, "accounting");
      path = path.join("/") + "/view";
      routes.dialog = DialogRouter.match(path);
    } else {
      routes.dialog =
        DialogRouter.match(path + "/view/") ||
        DialogRouter.match(path + "/view") ||
        DialogRouter.match(path) ||
        DialogRouter.match("/admin" + path + "/view/") ||
        DialogRouter.match("/admin" + path + "/view") ||
        DialogRouter.match("/admin" + path);
    }
    // Vue Router 4: `router.matcher.match(...)` was a Vue Router 3 internal
    // API; the modern equivalent is `router.resolve({ path })`, which returns
    // a route location with the same `.name` shape we check below.
    routes.route = router.resolve({ path: path + "/view" });
    if (routes.route.name === "404") {
      routes.route = router.resolve({ path: path + "/view/" });
      if (routes.route.name === "404") {
        routes.route = router.resolve({ path });
      }
    }
    return routes.dialog || routes.route.name !== "404" ? routes : null;
  }

  get user() {
    return this.data.uid
      ? store.state.main.users[this.data.uid] ||
          store.state.main.contacts[this.data.uid] ||
          null
      : null;
  }
}
